import { PublicClientApplication } from '@azure/msal-browser';
import { TENANT } from '@hems/util/src/constant/msal';
import { getHomeownerConfig, getPartnersConfig, getTenantByTenantId, getLoginRequestParams, } from '@hems/util/src/helper/authHelper';
const msalInstanceHomeowner = new PublicClientApplication(getHomeownerConfig());
const msalInstancePartners = new PublicClientApplication(getPartnersConfig());
const getMSALInstance = (tenant) => tenant === TENANT.HOMEOWNER ? msalInstanceHomeowner : msalInstancePartners;
export const acquireTokenSilent = async (account) => {
    if (!account.idTokenClaims?.tid) {
        return {
            accessToken: null,
            idToken: null,
        };
    }
    const tenant = getTenantByTenantId(account.idTokenClaims.tid);
    const { accessToken, idToken } = await getMSALInstance(tenant).acquireTokenSilent({
        ...getLoginRequestParams(tenant),
        account,
    });
    return {
        accessToken,
        idToken,
    };
};
export const logoutRedirectByAccountInfo = async (account) => {
    if (!account.idTokenClaims?.tid) {
        return;
    }
    const tenant = getTenantByTenantId(account.idTokenClaims.tid);
    await getMSALInstance(tenant).logoutRedirect({
        postLogoutRedirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI || '',
    });
};
